'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
), 'ViewAgenda');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/ViewAgenda.js
// module id = 967
// module chunks = 0